import { createComponentElement } from "../creators/createComponentElement";
import { useComponentData } from "../hooks/useComponentData";
import { ContentComponent } from "../types";
import FeaturedContent, {
  FeaturedContentParameters,
} from "@components/layouts/content/FeaturedContent";

const Component = createComponentElement((props, ref) => {
  const { getParameterValues, content, isLoading, ...other } =
    useComponentData<FeaturedContentParameters>(props, ref);

  const {
    image,
    shortDescription,
    badgeTitle,
    categories,
    coverImage,
    listeningIcon,
    listeningTitle,
    readingIcon,
    readingTitle,
  } = getParameterValues([
    "image",
    "shortDescription",
    "badgeTitle",
    "categories",
    "coverImage",
    "listeningIcon",
    "listeningTitle",
    "readingIcon",
    "readingTitle",
  ]);

  return (
    <FeaturedContent
      content={content}
      parameterValues={{
        image,
        shortDescription,
        badgeTitle,
        categories,
        coverImage,
        listeningIcon,
        listeningTitle,
        readingIcon,
        readingTitle,
      }}
      isLoading={isLoading}
      onItemPress={props.onItemPress}
    />
  );
});

export const FeaturedContentComponent: ContentComponent = {
  identifier: "COM:FEATUREDCONTENT:CARD:V2",
  component: Component,
};
